import { useState, useEffect, useRef, useCallback } from 'react';
import { useApiWithAuth } from '../api';
import type {
  CampaignListResponse,
  CampaignResponse,
} from '@/shared/communications/types';

export function useCampaigns() {
  const { invoke } = useApiWithAuth();
  const [campaigns, setCampaigns] = useState<CampaignResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const hasLoadedRef = useRef(false);

  const loadCampaigns = useCallback(async () => {
    try {
      setLoading(true);
      const response = (await invoke('/communications/campaigns', {
        method: 'GET',
      })) as unknown as CampaignListResponse;
      setCampaigns(response.data);
    } catch (error) {
      console.error('Error loading campaigns:', error);
    } finally {
      setLoading(false);
    }
  }, [invoke]);

  useEffect(() => {
    if (hasLoadedRef.current) {
      return;
    }

    hasLoadedRef.current = true;
    loadCampaigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    campaigns,
    loading,
    refetch: loadCampaigns,
  };
}
